import IconButton from "@/components/IconButton";

export interface MobileTableSortControlProps {
  onSortClick?: () => void;
}

export function MobileTableSortControl({ onSortClick }: MobileTableSortControlProps) {
  if (!onSortClick) return null;

  return (
    <div className="flex items-center lg:hidden -mt-5 -ml-2">
      <IconButton
        name="sort_by_alpha"
        onClick={onSortClick}
        title="Sort Table"
        data-testid="mobile-sort-button"
        skipMargin
      />
    </div>
  );
}
